import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapComponent} from './map/map.component';
import {GoogleMapsModule} from "@angular/google-maps";
import { MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MapToSearchComponent} from "./map-to-search/map-to-search.component";
import {PipesModule} from "../../providers/pipes/pipes.module";


@NgModule({
    declarations: [
        MapComponent,
        MapToSearchComponent
    ],
    exports: [
        MapComponent,
        MapToSearchComponent
    ],
    imports: [
        CommonModule,
        GoogleMapsModule,
        MatIconModule,
        MatButtonModule,
        PipesModule
    ]
})
export class MapsComponentModule {
}
